import {Resource} from "../../resources/common"
import {Customer} from "../../resources/customer"

export const isCustomerResource = (resource: Resource): resource is Customer =>
	resource.type == "individualCustomer" || resource.type == "businessCustomer" || resource.type == "businessFBOCustomer"

export const getCustomerName = (customer: Customer): string | undefined => {
	if (customer.type == "individualCustomer") {
		return `${customer.attributes.fullName.first} ${customer.attributes.fullName.last}`
	}
	if (customer.type == "businessCustomer" || customer.type == "businessFBOCustomer") {
		return customer.attributes.name
	}
	return undefined
}

export const getCustomerHref = (customer: Customer): string =>
	`/${customer.type == "individualCustomer" ? "individual" : "business"}/${customer.id}`

export function resolveCustomers(
	customerId: number | string | undefined,
	customerIds: Array<number | string> | undefined,
	include: Resource[] | undefined
): Customer[] {
	if (!include) return []
	const allIds = Array.from(
		new Set(
			[...(customerId ? [customerId] : []), ...(customerIds ?? [])]
				.filter((id): id is number | string => id !== undefined && id !== null)
				.map((id) => id.toString())
		)
	)
	return allIds
		.map((id) => include.find((resource) => isCustomerResource(resource) && resource.id == id))
		.filter((customer): customer is Customer => customer !== undefined)
}
